<template>
  <div id="generalEdit" class="sidebar-wrapper">
    <div class="d-flex flex-column justify-content-between">
      <div id="logoDiv" class="logo-wrapper">
        <img v-if="previewImage(cliente.Datos_json.Img_logo)" class="img-fluid" alt="Logo" :src="previewImage(cliente.Datos_json.Img_logo)">
      </div>
      <div id="editMain" class="sidebar-main">
        <!-- GENERAL -->
        <!-- Selector de Color -->
        <div v-if="show == 'general'" class="controllerDiv">
          <div id="main-color-picker" class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Elige el color principal</p>
            </div>
            <div class="colorDiv" v-show="showColors == 'false'">
              <div id="main-color-picker-button" v-on:click="showColorsDiv('true')">
                <p class="stretched-link">{{ editCliente.Datos_json.Color }}</p>
              </div>
            </div>
            <div class="colorsContainer" v-show="showColors == 'true'">
              <div id="main-color-picker-colors" class="colorsDisplay">
                <div class="colors" v-for="color in cliente.Colores" :key="color" :style="{ 'background-color': color }"
                  v-on:click="colorChange(color)"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Selector de fuente -->
        <div v-if="show == 'general'" class="controllerDiv">
          <div id="font-selector" class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Elige la fuente</p>
            </div>
            <select class="form-select notranslate" id="fontSelect" v-model="editCliente.Datos_json.Fuente"
              @change="onChangeFont()">
              <option v-for="fuente in cliente.Fuentes" :key="fuente">
                {{ fuente }}
              </option>
            </select>
          </div>
        </div>
        <!-- FavIcon -->
        <div v-if="show == 'general'" class="controllerDiv">
          <div id="favicon-editor" class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Editar Favicon</p>
            </div>
            <div class="controllerImgDrag" id="-1" v-on:click="inputImg(-1)" @dragover.prevent @drop.prevent="dragDrop">
              <div class="controllerImgMessage">
                <i class="fa-regular fa-solid fa-cloud-arrow-up" v-if="loadedImg == ''"></i>
                <div v-if="loadedImg == ''">Agrega o arrastra tu archivo aquí</div>
              </div>
              <input id="favicon-input" type="file" hidden ref="imgReader" @change="onChangeImg" accept="image/png,image/x-icon">
              <img :src="loadedImg" />
            </div>
            <div class="text-muted small pe-none mt-2">Sube una imagen PNG o ICO de 32x32 píxeles</div>
          </div>
        </div>
        <!-- HEADER -->
        <!-- Selector de Img -->
        <div v-if="show == 'header'" id="edit-logo-input-group" class="controllerDiv">
          <div class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Editar Logo</p>
            </div>
            <div class="controllerImgDrag" id="0" v-on:click="inputImg(0)" @dragover.prevent @drop.prevent="dragDrop">
              <div class="controllerImgMessage">
                <i class="fa-regular fa-solid fa-cloud-arrow-up" v-if="loadedImg == ''"></i>
                <div v-if="loadedImg == ''">Agrega o arrastra tu archivo aquí</div>
              </div>
              <input type="file" hidden ref="imgReader" @change="onChangeImg" accept="image/jpeg, image/jpg, image/png">
              <img :src="loadedImg" />
            </div>
            <div class="text-muted small pe-none mt-2">Sube una imagen del tipo PNG o JPG de hasta 2 MB</div>
          </div>
        </div>
        <div v-if="show == 'header'" id="edit-menu-extra" class="controllerDiv">
          <div class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Menú extra</p>
            </div>
            <div class="menu-extra-switch" role="tablist">
              <button type="button" role="tab" :class="{ active: menuExtraModo === 'url' }"
                :aria-selected="menuExtraModo === 'url'" @click="setMenuExtraModo('url')">
                <i class="fa-solid fa-link" aria-hidden="true"></i>
                Enlace
              </button>
              <button type="button" role="tab" :class="{ active: menuExtraModo === 'fichero' }"
                :aria-selected="menuExtraModo === 'fichero'" @click="setMenuExtraModo('fichero')">
                <i class="fa-solid fa-file" aria-hidden="true"></i>
                Fichero
              </button>
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Nombre del menú" class="form-control inputText"
                v-model="menuExtra.Nombre">
            </div>
            <div v-if="menuExtraModo === 'url'" class="menu-extra-url">
              <i class="fa-solid fa-link" aria-hidden="true"></i>
              <input type="url" placeholder="https://" class="form-control inputText" v-model="menuExtra.Url">
            </div>
            <div v-else>
              <input type="file" hidden ref="menuFileReader" accept=".pdf,.png,.jpg,.jpeg,.webp" @change="onMenuFile">
              <button v-if="!menuExtraFileName && !menuExtra.Url" type="button" class="menu-extra-drop"
                @click="openMenuFile" @dragover.prevent @drop.prevent="onMenuFileDrop">
                <i class="fa-solid fa-cloud-arrow-up" aria-hidden="true"></i>
                <span>Suelta el fichero aquí</span>
              </button>
              <div v-else class="menu-extra-picked">
                <div class="menu-extra-preview">
                  <img v-if="menuExtraPreviewKind() === 'image'" :src="toCdnImageUrl(menuExtraPreviewSrc())" alt="Vista previa">
                  <embed v-else-if="menuExtraPreviewKind() === 'pdf'" :src="toCdnImageUrl(menuExtraPreviewSrc())"
                    type="application/pdf">
                  <i v-else class="fa-solid fa-file" aria-hidden="true"></i>
                </div>
                <div class="menu-extra-file">
                  <span class="menu-extra-file-name">{{ menuExtraFileName || menuExtraFileLabel() }}</span>
                  <a v-if="menuExtra.Url && !menuExtraFileName" :href="toCdnImageUrl(menuExtra.Url)" target="_blank"
                    rel="noopener noreferrer" title="Abrir" aria-label="Abrir fichero">
                    <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
                  </a>
                  <button type="button" title="Quitar" aria-label="Quitar fichero" @click="clearMenuFile">
                    <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- INFORMACIÓN PRINCIPAL -->
        <div v-if="show === 'principal'" class="controllerDiv">
          <div class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Información principal</p>
            </div>
            <div id="main-title-input" class="inputTextDiv notranslate">
              <input type="text" placeholder="Titulo" class="form-control inputText" v-model="editCliente.Datos_json.Titulo_principal">
            </div>
            <div id="main-text-textarea" class="inputTextDiv notranslate">
              <trumbowyg ref="mainTextAreaEditor" v-model="editCliente.Datos_json.Descripcion_principal" class="form-control" :config="config">
              </trumbowyg>
            </div>
          </div>
        </div>

        <!-- SERVICIOS -->
        <div class="wrap-services" v-if="show == 'servicios'">
          <div class="controllerDiv" v-for="(service, index) in editCliente.Datos_json.Servicios.slice(0, 3)"
            :key="index">
            <div class="controllerInnerDiv">
              <div class="controllerTextDiv" style="justify-content: space-between; align-items: center;">
                <p class="controllerText">Servicio {{ index + 1 }}</p>
                <span class="action-box delete-btn">
                  <i class="fa-regular fa-trash-can" v-on:click="deleteService(index)"></i>
                </span>
              </div>
              <div class="inputTextDiv notranslate">
                <input type="text" class="form-control inputText" v-model="service.Titulo">
              </div>
              <div class="inputTextDiv notranslate">
                <trumbowyg v-model="service.Descripcion" class="form-control" :config="config"></trumbowyg>
              </div>
              <div class="controllerTextDiv">
                <p class="controllerText">Imagen</p>
              </div>
              <div class="controllerImgDrag" :id="'service' + (index + 1)" v-on:click="inputImg(index + 1)"
                @dragover.prevent @drop.prevent="dragDrop">
                <div class="controllerImgMessage">
                  <i class="fa-regular  fa-solid fa-cloud-arrow-up" v-if="!serviceloadedImg[index]"></i>
                  <div v-if="!serviceloadedImg[index]">Agrega o arrastra tu archivo aquí</div>
                </div>
                <img :src="serviceloadedImg[index]" />
              </div>
              <div class="text-muted small pe-none mt-2">Sube una imagen del tipo PNG o JPG de hasta 2 MB</div>
            </div>
          </div>
          <input type="file" hidden ref="imgReader" @change="onChangeImg" accept="image/jpeg, image/jpg, image/png">
        </div>

        <!-- SOBRE NOSOTROS -->
        <div v-if="(show == 'sobreNosotros' ||show == 'PantallaSobreNosotros')">
          <div class="controllerDiv">
            <div class="controllerInnerDiv">
              <div class="controllerTextDiv" style="justify-content: space-between; align-items: center;">
                <p class="controllerText">Descripción sobre el negocio</p>
              </div>
              <div class="inputTextDiv notranslate">
                <trumbowyg v-if="show== 'sobreNosotros'" v-model="editCliente.Datos_json.Descripcion_sobre_nosotros_corta" class="form-control"
                  :config="config"></trumbowyg>
                <trumbowyg v-if="show== 'PantallaSobreNosotros'" v-model="editCliente.Datos_json.Descripcion_sobre_nosotros" class="form-control"
                  :config="config"></trumbowyg>
              </div>
              <div class="controllerTextDiv">
                <p class="controllerText">Cambiar imagen</p>
              </div>
              <div class="controllerImgDrag" id="0" v-on:click="inputImg(-2)" @dragover.prevent @drop.prevent="dragDrop">
                <div class="controllerImgMessage">
                  <i class="fa-regular fa-solid fa-cloud-arrow-up" v-if="loadedImg == ''"></i>
                  <div v-if="loadedImg == ''">Agrega o arrastra tu archivo aquí</div>
                </div>
                <input type="file" hidden ref="imgReader" @change="onChangeImg"
                  accept="image/jpeg, image/jpg, image/png">
                <img :src="loadedImg" />
              </div>
              <div class="text-muted small pe-none mt-2">Sube una imagen del tipo PNG o JPG de hasta 2 MB</div>
            </div>
          </div>
        </div>
        <!-- DIRECCION -->
        <div v-if="show == 'find-us'" class="controllerDiv">
          <div class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Localización</p>
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Calle y Número" class="form-control inputText" v-model="editCliente.Datos_json.Calle">
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Código Postal *" class="form-control inputText" v-model="editCliente.Datos_json.cp">
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Localidad *" class="form-control inputText" v-model="editCliente.Datos_json.Localidad">
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Provincia *" class="form-control inputText" v-model="editCliente.Datos_json.Provincia">
            </div>
            <div class="controllerTextDiv">
              <p class="controllerText">Mapa Google</p>
            </div>
            <div class="inputTextDiv">
              <input type="text" placeholder="Dirección Google Maps" class="form-control inputText" v-model="editCliente.Datos_json.MapaGoogle">
            </div>
          </div>
        </div>
        <!-- CRITICAS -->
        <div class=infoDiv v-if="show == 'criticas'">
          <i class="fa-solid fa-circle-info"></i>
          <p> Estas reseñas serán obtenidas de Google...</p>
        </div>

        <!-- DATOS DE CONTACTO -->
        <!-- Selector de Img -->
        <div v-if="show == 'contacto'" class="controllerDiv">
          <div class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Cambiar imagen</p>
            </div>
            <div class="controllerImgDrag" id="0" v-on:click="inputImg(-2)" @dragover.prevent @drop.prevent="dragDrop">
              <div class="controllerImgMessage">
                <i class="fa-regular fa-solid fa-cloud-arrow-up" v-if="loadedImg == ''"></i>
                <div v-if="loadedImg == ''">Agrega o arrastra tu archivo aquí</div>
              </div>
              <input type="file" hidden ref="imgReader" @change="onChangeImg" accept="image/jpeg, image/jpg, image/png">
              <img :src="loadedImg" />
            </div>
            <div class="text-muted small pe-none mt-2">Sube una imagen del tipo PNG o JPG de hasta 2 MB</div>

            <div class="controllerTextDiv mt-4">
              <p class="controllerText">Visibilidad de los datos de contacto</p>
            </div>
            <div class="contact-visibility-options">
              <label class="contact-visibility-row form-check d-flex align-items-start gap-2 mb-3">
                <input type="checkbox" class="form-check-input mt-1 flex-shrink-0"
                  :true-value="1" :false-value="0"
                  v-model="editCliente.Datos_json.Form_contacto.Ocultar_Form_contacto" />
                <span class="flex-grow-1">
                  <span class="d-flex align-items-center gap-2 flex-wrap">
                    <span>Ocultar formulario de contacto</span>
                    <span class="contact-hint-badge" tabindex="0"
                      title="Si publicas con esta opción, los visitantes no verán el formulario y no podrán escribirte desde la web por ese canal.">?</span>
                  </span>
                </span>
              </label>
              <label class="contact-visibility-row form-check d-flex align-items-start gap-2 mb-3">
                <input type="checkbox" class="form-check-input mt-1 flex-shrink-0"
                  :true-value="1" :false-value="0"
                  v-model="editCliente.Datos_json.Form_contacto.Ocultar_btn_call" />
                <span class="flex-grow-1">
                  <span class="d-flex align-items-center gap-2 flex-wrap">
                    <span>Ocultar botón llamada</span>
                    <span class="contact-hint-badge" tabindex="0"
                      title="Si publicas con esta opción, no se mostrará el acceso rápido a llamada y los clientes no podrán iniciar contacto por teléfono desde ese botón.">?</span>
                  </span>
                </span>
              </label>
              <label v-if="Number(cliente.Tiene_chatbot) > 0" class="contact-visibility-row form-check d-flex align-items-start gap-2 mb-3">
                <input type="checkbox" class="form-check-input mt-1 flex-shrink-0"
                  :true-value="1" :false-value="0"
                  v-model="editCliente.Datos_json.Form_contacto.Ocultar_btn_whs" />
                <span class="flex-grow-1">
                  <span class="d-flex align-items-center gap-2 flex-wrap">
                    <span>Ocultar botón WhatsApp</span>
                    <span class="contact-hint-badge" tabindex="0"
                      title="Si publicas con esta opción, se oculta WhatsApp en esta sección y los visitantes no podrán abrirte conversación desde ahí.">?</span>
                  </span>
                </span>
              </label>
              <label class="contact-visibility-row form-check d-flex align-items-start gap-2 mb-0">
                <input type="checkbox" class="form-check-input mt-1 flex-shrink-0"
                  :true-value="1" :false-value="0"
                  v-model="editCliente.Datos_json.Form_contacto.Ocultar_btn_mail" />
                <span class="flex-grow-1">
                  <span class="d-flex align-items-center gap-2 flex-wrap">
                    <span>Ocultar botón email</span>
                    <span class="contact-hint-badge" tabindex="0"
                      title="Si publicas con esta opción, no verán el acceso por email en esta zona y no podrán usar ese atajo desde la web.">?</span>
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- PANTALLA SERVICIOS MODIFICAR SERVICIOS -->
        <div v-if="show == 'listServicios'">
          <div class="controllerDiv" v-for="(service, index) in editCliente.Datos_json.Servicios" :key="index">
            <div class="controllerInnerDiv">
              <div class="controllerTextDiv" style="justify-content: space-between; align-items: center;">
                <p class="controllerText">Servicio {{ index + 1 }}</p>
                <span class="action-box delete-btn">
                  <i class="fa-regular fa-trash-can" v-on:click="deleteService(index)"></i>
                </span>
              </div>
              <div :id="`servicio-${index+1}-name-input`" class="inputTextDiv notranslate">
                <input type="text" class="form-control inputText" v-model="service.Titulo">
              </div>
              <div :id="`servicio-${index+1}-description-input`" class="inputTextDiv notranslate">
                <trumbowyg v-model="service.Descripcion" class="form-control" :config="config"></trumbowyg>
              </div>
              <div class="controllerTextDiv">
                <p class="controllerText">Imagen principal</p>
              </div>
              <div class="controllerImgDrag" :id="'service' + (index + 1)" v-on:click="inputImg(index + 1)"
                @dragover.prevent @drop.prevent="dragDrop">
                <div class="controllerImgMessage">
                  <i class="fa-regular fa-solid fa-cloud-arrow-up" v-if="!serviceloadedImg[index]"></i>
                  <div v-if="!serviceloadedImg[index]">Agrega o arrastra tu archivo aquí</div>
                </div>
                <img :src="serviceloadedImg[index]" />
              </div>
              <div class="text-muted small pe-none mt-2">Sube una imagen del tipo PNG o JPG de hasta 2 MB</div>
            </div>
          </div>
          <input type="file" hidden ref="imgReader" @change="onChangeImg" accept="image/jpeg, image/jpg, image/png">
        </div>

        <!-- FOOTER -->
        <div v-if="show == 'footer'" class="controllerDiv">
          <div class="controllerInnerDiv">
            <div class="controllerTextDiv">
              <p class="controllerText">Redes sociales</p>
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Faceboook" class="form-control inputText"
                v-model="editCliente.Datos_json.Perfil_facebook">
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Instagram" class="form-control inputText"
                v-model="editCliente.Datos_json.Perfil_instagram">
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="LinkedIn" class="form-control inputText"
                v-model="editCliente.Datos_json.Perfil_linkedin">
            </div>
            <div class="inputTextDiv notranslate">
              <input type="text" placeholder="Twitter" class="form-control inputText"
                v-model="editCliente.Datos_json.Perfil_twitter">
            </div>
            <div class="controllerTextDiv" style="display: flex; justify-content: space-between; align-items: flex-start;">
              <div style="display:flex; flex-direction:column;">
                <p class="controllerText" style="margin-bottom: .5em;">Imagen para el pie de página</p>
                <p>La imagen que subas aparecerá en el pie de página de tu web, reemplazando el actual</p>
              </div>
              <span class="action-box delete-btn" title="Eliminar imagen" v-on:click.prevent="deleteFooterImage">
                <i class="fa-regular fa-trash-can p-2"></i>
              </span>
            </div>
            <div class="controllerImgDrag" id="0" v-on:click="inputImg(-3)" @dragover.prevent @drop.prevent="dragDrop">
              <div class="controllerImgMessage">
                <i class="fa-regular fa-solid fa-cloud-arrow-up" v-if="loadedImg == ''"></i>
                <div v-if="loadedImg == ''">Agrega o arrastra tu archivo aquí</div>
              </div>
              <input type="file" hidden ref="imgReader" @change="onChangeImg" accept="image/jpeg, image/jpg, image/png">
              <img :src="loadedImg" />
            </div>
            <div class="text-muted small pe-none mt-2">Sube una imagen del tipo PNG o JPG de hasta 2 MB</div>
          </div>
        </div>

      </div>
      <div class="sidebar-footer gap-2 px-5 py-4" v-if="show != 'criticas'">
        <button class="btn btn-outline-primary" v-on:click="addService('home')" v-if="show == 'servicios'">Agregar
          servicio</button>
        <button class="btn btn-outline-primary" v-on:click="addService('servicios')" v-if="show == 'listServicios'">Agregar
          servicio</button>
        <button id="save-button" class="btn btn-primary" v-on:click="confirmarGuardar">Guardar</button>
      </div>
    </div>

  </div>
</template>

<script class="notranslate">
import { useToast } from "vue-toastification";
import axios from "axios"
import { trumbowygEditor } from "@/sharedState";
import { env, toCdnImageUrl } from "@/helpers";

export default {
  name: 'GeneralEdit',
  props: {
    show: String,
    cliente: Object,
    folder: String,
    timeStamp: [String, Number]
  },

  mounted() {
    this.editCliente = this.cliente;
    if (this.show === 'contacto') this.ensureFormContactoBlock();
    if (this.show === 'header') this.loadMenuExtra();
  },
  updated() {
    trumbowygEditor.value = this.$refs.mainTextAreaEditor
  },
  watch: {
    show(val) {
      if (val === 'contacto') this.ensureFormContactoBlock();
      if (val === 'header') this.loadMenuExtra();
      this.cleanImg();
    },
    menuExtra: {
      deep: true,
      handler() {
        this.syncMenuExtra();
      },
    },
  },
  data() {
    return {
      config: {
        autogrow: true,
        removeformatPasted: true,
        btns: [
          ['undo', 'redo'], // Only supported in Blink browsers
          ['strong', 'em', 'del'],
          ['link'],
          ['superscript'],
          ['removeformat']
        ]
      },
      showColors: 'false',
      loadedImg: '',
      loadedImgType: '',
      serviceloadedImg: [],
      serviceloadedImgType: [],
      savedImg: [],
      deletedImg: [],
      imgInputSelected: 0,
      editCliente: {
        Datos_json: {
          Color: "#4f8cf0",
          Servicios: []
        }
      },
      menuExtra: { Nombre: '', Url: '', Tipo: 'url' },
      menuExtraModo: 'url',
      menuExtraDraftUrl: '',
      menuExtraDraftFileUrl: '',
      menuExtraFile: '',
      menuExtraFileName: '',
      menuExtraRest: [],
    }
  },
  setup() {
    // Get toast interface
    const toast = useToast();
    return { toast }
  },
  methods: {
    toCdnImageUrl,
    previewImage(fileName) {
      if (!this.folder || !fileName || !this.cliente.urlImg) return '';
      return this.cliente.urlImg + '/' + this.folder + '/' + fileName + '?v=' + this.timeStamp;
    },
    /** Convierte a 0/1 (JSON sin booleanos). */
    contactFlagTo01(v) {
      if (v === 1 || v === '1') return 1;
      if (v === true) return 1;
      if (typeof v === 'string' && v.trim() === '1') return 1;
      return 0;
    },
    normalizeFormContacto01(dj) {
      const fc = dj?.Form_contacto;
      if (!fc || typeof fc !== 'object') return;
      const to01 = this.contactFlagTo01;
      fc.Ocultar_Form_contacto = to01(fc.Ocultar_Form_contacto ?? fc.ocultar_form_contacto);
      fc.Ocultar_btn_call = to01(fc.Ocultar_btn_call ?? fc.ocultar_btn_call);
      fc.Ocultar_btn_mail = to01(fc.Ocultar_btn_mail ?? fc.ocultar_btn_mail);
      fc.Ocultar_btn_whs = to01(fc.Ocultar_btn_whs ?? fc.ocultar_btn_whs);
      delete fc.ocultar_form_contacto;
      delete fc.ocultar_btn_call;
      delete fc.ocultar_btn_mail;
      delete fc.ocultar_btn_whs;
    },
    /** Asegura `Form_contacto` en Datos_json y migra claves sueltas antiguas. */
    ensureFormContactoBlock() {
      const dj = this.editCliente?.Datos_json;
      if (!dj) return;
      const to01 = this.contactFlagTo01.bind(this);
      const readLegacy = (nestedKey, legacyKeys) => {
        if (dj.Form_contacto && typeof dj.Form_contacto === 'object' && dj.Form_contacto[nestedKey] !== undefined) {
          return to01(dj.Form_contacto[nestedKey]);
        }
        for (let i = 0; i < legacyKeys.length; i += 1) {
          const lk = legacyKeys[i];
          if (dj[lk] !== undefined) return to01(dj[lk]);
        }
        return 0;
      };
      if (!dj.Form_contacto || typeof dj.Form_contacto !== 'object') {
        dj.Form_contacto = {
          Ocultar_Form_contacto: readLegacy('Ocultar_Form_contacto', ['Ocultar_Form_contacto', 'ocultar_form_contacto']),
          Ocultar_btn_call: readLegacy('Ocultar_btn_call', ['Ocultar_btn_call', 'ocultar_btn_call']),
          Ocultar_btn_mail: readLegacy('Ocultar_btn_mail', ['Ocultar_btn_mail', 'ocultar_btn_mail']),
          Ocultar_btn_whs: readLegacy('Ocultar_btn_whs', ['Ocultar_btn_whs', 'ocultar_btn_whs']),
        };
      }
      this.normalizeFormContacto01(dj);
    },
    loadMenuExtra() {
      const raw = this.editCliente?.Datos_json?.Menus_extra;
      const list = Array.isArray(raw) ? raw : [];
      const first = list[0] && typeof list[0] === 'object' ? list[0] : {};
      const tipo = first.Tipo === 'fichero' ? 'fichero' : 'url';
      const url = String(first.Url || '');
      this.menuExtraRest = list.slice(1);
      this.menuExtraModo = tipo;
      this.menuExtraDraftUrl = tipo === 'url' ? url : '';
      this.menuExtraDraftFileUrl = tipo === 'fichero' ? url : '';
      this.menuExtraFile = '';
      this.menuExtraFileName = '';
      this.menuExtra = {
        Nombre: String(first.Nombre || ''),
        Url: url,
        Tipo: tipo,
      };
      this.syncMenuExtra();
    },
    setMenuExtraModo(modo) {
      if (modo === this.menuExtraModo) return;
      if (this.menuExtraModo === 'url') this.menuExtraDraftUrl = String(this.menuExtra.Url || '');
      else this.menuExtraDraftFileUrl = String(this.menuExtra.Url || '');
      this.menuExtraModo = modo;
      this.menuExtra.Tipo = modo;
      this.menuExtra.Url = modo === 'url' ? this.menuExtraDraftUrl : this.menuExtraDraftFileUrl;
      this.syncMenuExtra();
    },
    menuExtraExtension() {
      const source = this.menuExtraFileName || this.menuExtraFileLabel();
      return (String(source).split('.').pop() || '').toLowerCase().split('?')[0];
    },
    menuExtraPreviewKind() {
      const extension = this.menuExtraExtension();
      if (['png', 'jpg', 'jpeg', 'webp'].includes(extension)) return 'image';
      if (extension === 'pdf') return 'pdf';
      return '';
    },
    menuExtraPreviewSrc() {
      if (this.menuExtraFile) {
        const mime = {
          png: 'image/png',
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          webp: 'image/webp',
          pdf: 'application/pdf',
        }[this.menuExtraExtension()] || 'application/octet-stream';
        return `data:${mime};base64,${this.menuExtraFile}`;
      }
      return String(this.menuExtra?.Url || '');
    },
    menuExtraFileLabel() {
      const url = String(this.menuExtra?.Url || '');
      const name = url.split('?')[0].split('/').pop();
      try {
        return decodeURIComponent(name || url);
      } catch (err) {
        return name || url;
      }
    },
    openMenuFile() {
      this.$refs.menuFileReader.click();
    },
    onMenuFileDrop(event) {
      const file = event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) this.readMenuFile(file);
    },
    clearMenuFile() {
      this.menuExtraFile = '';
      this.menuExtraFileName = '';
      this.menuExtra.Url = '';
      this.menuExtraDraftFileUrl = '';
      if (this.$refs.menuFileReader) this.$refs.menuFileReader.value = '';
      this.syncMenuExtra();
    },
    onMenuFile(event) {
      const file = event.target.files && event.target.files[0];
      if (file) this.readMenuFile(file);
    },
    readMenuFile(file) {
      const extension = (file.name.split('.').pop() || '').toLowerCase();
      if (!['pdf', 'png', 'jpg', 'jpeg', 'webp'].includes(extension)) {
        this.toast.error('El fichero debe ser PDF, PNG, JPG o WEBP');
        if (this.$refs.menuFileReader) this.$refs.menuFileReader.value = '';
        return;
      }
      if (file.size > 8 * 1024 * 1024) {
        this.toast.error('El fichero no puede superar 8 MB');
        if (this.$refs.menuFileReader) this.$refs.menuFileReader.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || '');
        this.menuExtraFile = result.includes('base64,') ? result.split('base64,')[1] : '';
        this.menuExtraFileName = file.name;
      };
      reader.readAsDataURL(file);
    },
    syncMenuExtra() {
      const dj = this.editCliente?.Datos_json;
      if (!dj) return;
      const name = String(this.menuExtra?.Nombre || '');
      const url = String(this.menuExtra?.Url || '');
      const rest = Array.isArray(this.menuExtraRest) ? this.menuExtraRest : [];
      const tipo = this.menuExtraModo === 'fichero' ? 'fichero' : 'url';
      if (!name.trim() && !url.trim()) {
        dj.Menus_extra = rest.slice();
        return;
      }
      dj.Menus_extra = [{ Nombre: name, Url: url, Tipo: tipo }, ...rest];
    },
    dropEmptyMenuExtra() {
      const dj = this.editCliente?.Datos_json;
      if (!dj || !Array.isArray(dj.Menus_extra)) return;
      dj.Menus_extra = dj.Menus_extra.filter((item) => {
        if (!item || typeof item !== 'object') return false;
        const name = String(item.Nombre || '').trim();
        const url = String(item.Url || '').trim();
        return name || url;
      });
    },
    async comprobarMenuExtra() {
      const name = String(this.menuExtra.Nombre || '').trim();
      let url = String(this.menuExtra.Url || '').trim();
      const hasFile = Boolean(this.menuExtraFile);
      this.menuExtra.Nombre = name;
      this.menuExtra.Url = url;
      if (!name && !url && !hasFile) {
        this.syncMenuExtra();
        return true;
      }
      if (!name) {
        this.toast.error('El menú extra necesita un nombre');
        return false;
      }
      if (this.menuExtraModo === 'fichero') {
        if (hasFile) {
          const uploaded = await this.guardarDocumento(this.menuExtraFileName, this.menuExtraFile);
          if (!uploaded || uploaded.status != 200 || !uploaded.data?.url) {
            this.toast.error('No se ha podido subir el fichero');
            return false;
          }
          url = uploaded.data.url;
          this.menuExtra.Url = url;
          this.menuExtraDraftFileUrl = url;
          this.menuExtraFile = '';
          this.menuExtraFileName = '';
        }
        if (!url) {
          this.toast.error('Sube un fichero para el menú extra');
          return false;
        }
      } else {
        if (!url) {
          this.toast.error('El menú extra necesita una URL');
          return false;
        }
        let parsed;
        try {
          parsed = new URL(url);
        } catch (err) {
          this.toast.error('La URL del menú extra no es válida');
          return false;
        }
        if (parsed.protocol !== 'https:') {
          this.toast.error('La URL del menú extra debe empezar por https://');
          return false;
        }
      }
      this.menuExtra.Tipo = this.menuExtraModo === 'fichero' ? 'fichero' : 'url';
      this.syncMenuExtra();
      return true;
    },
    confirmarGuardar() {
      this.$emit('modalSave');
    },
    async guardar() {
      if (window.send_analytics != undefined) {
        window.send_analytics("Click.Guardar");
      }
      var response;
      switch (this.show) {
        case 'servicios':
        case 'listServicios':
          if (this.comprobarServicios()) {
            for (var i in this.savedImg) {
              if (this.savedImg[i] != null && this.savedImg[i] != ''){
                response = await this.guardarImg(this.folder + '/' + this.savedImg[i].id, this.savedImg[i].img, this.savedImg[i].title, 'services', this.savedImg[i].description);
                if (response.status != 200){
                  
                  return false;
                }
              }
            }
            for (var x in this.deletedImg) {
              if (this.deletedImg[x] != null && this.deletedImg[x] != ''){
                response = await this.borrarImg(this.folder + '/' + this.deletedImg[x]);
                if(!response){
                  //return false;
                }else if (response.status != 200){
                  return false;
                }
              }
            }
            
            return true;
          }
          break;
        case 'header':
          if (!await this.comprobarMenuExtra()) return false;
          if (this.loadedImg) {
            response = await this.guardarImg(this.folder + '/logo' + this.loadedImgType, this.loadedImg.split("base64,")[1], this.removeAccents('Logo de ' + this.editCliente.Datos_json.Titulo_principal), 'logo');
            if (response.status == 200) {
              this.editCliente.Datos_json.Img_logo = 'logo' + this.loadedImgType;
              return true;
            }
            return false;
          }
          return true;
        case 'principal':
          return this.comprobarPrincipal();
        case 'contacto':
          if (this.loadedImg) {
            response = await this.guardarImg(this.folder + '/contacto' + this.loadedImgType, this.loadedImg.split("base64,")[1], this.removeAccents('Contacta con ' + this.editCliente.Datos_json.Titulo_principal), 'contact');
            if (response.status == 200) {
              this.editCliente.Datos_json.Img_contacto = 'contacto' + this.loadedImgType;
              return true;
            }
            return false;
          }
          return true;
        case 'sobreNosotros':
        case 'PantallaSobreNosotros':
          if (this.comprobarSobreNosotros()) {
            if (this.loadedImg) {
              response = await this.guardarImg(this.folder + '/sobreNosotros' + this.loadedImgType, this.loadedImg.split("base64,")[1], this.removeAccents('Sobre ' + this.editCliente.Datos_json.Titulo_principal), 'about_us', this.cleanDescription(this.editCliente.Datos_json.Descripcion_sobre_nosotros));
              if (response.status == 200) {
                this.editCliente.Datos_json.Img_sobre_nosotros = 'sobreNosotros' + this.loadedImgType;
                return true;
              } else
                return false
            }
            return true;
          }
          break;
        case 'footer':
          if (this.comprobarFooter()) {
            // Primero subir nueva imagen si hay
            let ok = await this.comprobarFooterImg();
            if (ok === false) return false;

            // Después procesar borrados pendientes que correspondan al footer
            for (var z in this.deletedImg) {
              const name = this.deletedImg[z];
              try {
                if (!name.startsWith('footer')) continue; // solo borrar si es de footer
                let resp = await this.borrarImg(this.folder + '/' + name);

                if (resp && resp.status && resp.status != 200) {
                  return false;
                }
              } catch (e) {
                // Ignorar errores de borrado remoto
              }
            }

            // Eliminar el nombre de la lista de borrado para no intentar borrar dos veces
            this.deletedImg = this.deletedImg.filter(name => !name.startsWith('footer'));

            return true;
          }
          return this.comprobarFooter();
        case 'general':
          if (this.loadedImg) {
            response = await this.guardarImg(this.folder + '/favicon' + this.loadedImgType, this.loadedImg.split("base64,")[1], this.removeAccents('Favicon de '+ this.editCliente.Datos_json.Titulo_principal), 'favicon');
            if (response.status == 200) {
              this.editCliente.Datos_json.FavIcon = 'favicon' + this.loadedImgType;
              return true;
            } else
              return false
          }
          return true;
        case 'find-us':
          return this.comprobarDireccion();
        default:
          return false;
      }
      return false
    },
    passEditClient() {
      const dj = this.editCliente.Datos_json;
      if (this.show === 'contacto') {
        this.ensureFormContactoBlock();
        const fc = dj.Form_contacto;
        const to01 = this.contactFlagTo01;
        fc.Ocultar_Form_contacto = to01(fc.Ocultar_Form_contacto);
        fc.Ocultar_btn_call = to01(fc.Ocultar_btn_call);
        fc.Ocultar_btn_mail = to01(fc.Ocultar_btn_mail);
        if (Number(this.cliente?.Tiene_chatbot) > 0) {
          fc.Ocultar_btn_whs = to01(fc.Ocultar_btn_whs);
        } else {
          fc.Ocultar_btn_whs = 0;
        }
        this.normalizeFormContacto01(dj);
      }
      if (this.show === 'header') this.syncMenuExtra();
      this.dropEmptyMenuExtra();
      return dj;
    },
    onChangeImg() {
      let file = this.$refs.imgReader.files[0];
      this.readImg(file);
    },
    inputImg(id) {
      this.imgInputSelected = id;
      this.$refs.imgReader.click();
    },
    dragDrop(e) {
      let id = e.path[0].id.replace('service', '');
      if (id)
        this.imgInputSelected = id;
      else
        this.imgInputSelected = e.path[1].id;
      let file = e.dataTransfer.files[0];
      this.readImg(file);
    },
    readImg(file) {
      let validExtensions = ["image/jpeg", "image/jpg", "image/png", "image/x-icon"]; // tipos de img permitidos
      // Max 2MB de img
      if (file.size <= 16000000) {
        if (validExtensions.includes(file.type)) {
          let type = '.' + file.type.replace('image/', '');
          // Si el fichero es de tipo ico le agregamos la extension
          if (type == '.x-icon')
            type = ".ico";
          const fileReader = new FileReader();
          fileReader.onload = () => {
            // Si es mayor que 0 indica que es un servicio
            if (this.imgInputSelected > 0) {
              this.serviceloadedImg[this.imgInputSelected - 1] = fileReader.result;
              this.serviceloadedImgType[this.imgInputSelected - 1] = type;
              this.$emit('uploadImage', fileReader.result, 680, 680, 300, 250, 1/1);
            }
            else {
              // Si estamos intentando subir el favicon , comprobamos el tamaño en px
              if (this.imgInputSelected == -1) {
                var _URL = window.URL || window.webkitURL;
                var img;
                img = new Image();
                img.onload = () => {
                  if (img.width > 32 || img.height > 32)
                    this.toast.error("El tamaño máximo permitido para un favicon es 32px x 32px")
                  else {
                    this.loadedImg = fileReader.result; //passing user file source in fileURL variable
                    this.loadedImgType = type;
                    this.$emit('uploadImage', fileReader.result, 32, 32, 400, 250, 1/1);
                  }
                };
                img.src = _URL.createObjectURL(file);
              //Para la imagen de contacto y sobre nosotros
              } else if (this.imgInputSelected == -2) {                
                this.loadedImg = fileReader.result; //passing user file source in fileURL variable
                this.loadedImgType = type;
                this.$emit('uploadImage', fileReader.result, 680, 515, 400, 300, 4/3);
              //Para la imagen del logo
              } else if (this.imgInputSelected == -3) {                
                this.loadedImg = fileReader.result; //passing user file source in fileURL variable
                this.loadedImgType = type;
                this.$emit('uploadImage', fileReader.result, 1000, 100, 1000, 100, 100/10);
              } else {                
                this.loadedImg = fileReader.result; //passing user file source in fileURL variable
                this.loadedImgType = type;
                this.$emit('uploadImage', fileReader.result, 300, 181, 400, 100, 16/6);
              }
            }
          }
          fileReader.readAsDataURL(file);
        } else {
          this.toast.error("Esto no es un formato de imagen valido");
        }
      } else {
        this.toast.error("El tamaño de archivo máximo permitido son 2MB");
      }

    },
    deleteService(index) {
      if (this.editCliente.Datos_json.Servicios.length > 1) {
        this.deletedImg.push(this.cliente.Datos_json.Servicios[index].Img);
        this.editCliente.Datos_json.Servicios.splice(index, 1);
        this.toast.info("Servicio eliminado");
        this.serviceloadedImg.splice(index, 1);
      } else {
        this.toast.error("Se requiere min 1 servicio");
      }
    },
    async deleteFooterImage() {
      // Solo permitir eliminar si existe una imagen personalizada (no la por defecto)
      const current = this.editCliente && this.editCliente.Datos_json ? this.editCliente.Datos_json.Img_Footer : null;
      if (!current || current === '') {
        this.toast.error('No hay pie de página personalizado para eliminar');
        return;
      }

      // Confirmación del usuario
      if (!confirm('¿Eliminar la imagen del pie de página?')) return;

      // Marcamos la imagen para borrado en el guardado (borrado "falso" hasta guardar)
      const originalName = current;
      if (originalName && originalName != '' && !this.deletedImg.includes(originalName)) {
        this.deletedImg.push(originalName);
      }

      // Limpiar referencia y preview
      this.editCliente.Datos_json.Img_Footer = ""; // Mantenemos null para saber que la imagen ha sido alterada por el usuario y que NO debe cargar la de por defecto
      this.loadedImg = '';
      this.toast.info('Imagen del pie de página eliminada');
    },
    addService(origen) {
      var max = 0;
      if(origen == 'home')
        max = env.VUE_APP_MAX_HOME_SERVICES;
      else
        max = env.VUE_APP_MAX_SERVICES;
      if (this.editCliente.Datos_json.Servicios.length < max) {
        this.editCliente.Datos_json.Servicios.push({ Titulo: '', Descripcion: '', Img: '' });
        this.toast.info("Servicio añadido");
      } else {
        this.toast.error("Se ha alcanzado el número max de servicios para esta sección");
      }
    },
    showColorsDiv(value) {
      this.showColors = value;
    },
    colorChange(newColor) {
      this.editCliente.Datos_json.Color = newColor;
      this.editCliente.Datos_json.Contraste = this.cliente.MatrizColores[newColor];
      this.$emit('colorChanged', this.editCliente.Datos_json.Color);
      this.showColorsDiv('false');
    },
    cleanImg() {
      this.loadedImg = '';
      this.loadedImgType = '';
      this.serviceloadedImg = [];
      this.serviceloadedImgType = [];
      this.imgInputSelected = 0;
    },
    async guardarImg(filename, base64img, title='', purpose='', description='') {
      let url = env.VUE_APP_API + 'guardar_imagen_cms';
      let img_metadata = {
        "title": title,
        "description": description,
        "purpose": purpose
      }
      // Eliminamos los campos vacios
      for (var i in img_metadata) {
        if (img_metadata[i] == '' || img_metadata[i] == undefined)
          delete img_metadata[i];
      }
      let body = {
        "name": filename,
        "img_str": base64img,
        "img_metadata" : img_metadata
      };
      let headers = {
        headers: {
          'Authorization': env.VUE_APP_APIKEY
        }
      };
      let response = await axios.post(url, body, headers);
      return response

    },
    async guardarDocumento(filename, base64file) {
      let url = env.VUE_APP_API + 'guardar_documento_cms';
      let body = {
        client_id: this.cliente.Cliente_id,
        name: filename,
        file_str: base64file,
      };
      let headers = {
        headers: {
          'Authorization': env.VUE_APP_APIKEY
        }
      };
      try {
        return await axios.post(url, body, headers);
      } catch (error) {
        return error.response;
      }
    },
    async borrarImg(filename) {
      let url = env.VUE_APP_API + 'borrar_imagen';
      let body = {
        "name": filename,
      };
      let headers = {
        headers: {
          'Authorization': env.VUE_APP_APIKEY
        }
      };
      try {
        let response = await axios.post(url, body, headers, {
          timeout: 5000
        });
        return response;
      } catch (error) {
        this.toast.warning("El servicio eliminado no tenia imagen, se mantendra la imagen por defecto.")
      }
    },
    showCropImg(img) {
      if (this.imgInputSelected > 0)
        this.serviceloadedImg[this.imgInputSelected - 1] = img;
      else
        this.loadedImg = img;
    },
    /* COMPROBAR CAMPOS */
    comprobarPrincipal() {
      if (this.editCliente.Datos_json.Titulo_principal.replace(/\s+/g, '') == '' || this.editCliente.Datos_json.Descripcion_principal.replace(/\s+/g, '') == '') {
        this.errorForm();
        return false;
      }
      return true;
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, '');
    },
    cleanDescription(description) {
      let desc = description.replace(/<[^>]*>?/gm, '');
      return this.removeAccents(desc);
    },
    comprobarServicios() {
      for (var i in this.serviceloadedImg) {
        var name = Date.now() + "_" + i + this.serviceloadedImgType[i];
        var description = this.cleanDescription(this.editCliente.Datos_json.Servicios[i].Descripcion);
        var title = this.removeAccents(this.editCliente.Datos_json.Servicios[i].Titulo);
        var originalImg = this.cliente.Datos_json.Servicios[i].Img; // La guardamos para borrarla, pues va a ser reemplazada
        this.editCliente.Datos_json.Servicios[i].Img = name;
        this.savedImg.push({ id: name, img: this.serviceloadedImg[i].split("base64,")[1], title: title, description: description });
        // Borramos la imagen original
        if (originalImg != null && 
        originalImg != '' && 
        originalImg != name && 
        !this.deletedImg.includes(originalImg)) {
          this.borrarImg(this.folder + '/' + originalImg);  
          // Las eliminamos de imagenes guardadas
          this.savedImg = this.savedImg.filter(img => img.id !== originalImg);
        }
      }
      for (var x in this.editCliente.Datos_json.Servicios) {
        let service = this.editCliente.Datos_json.Servicios[x];
        if (service.Titulo.replace(/\s+/g, '') == '' || service.Descripcion.replace(/\s+/g, '') == '') {
          this.errorForm();
          return false;
        }
        if(service.Img){
          if(service.Img.toString().replace(/\s+/g, '') == ''){
            this.errorForm();
            return false;
          }
        }

      }
      return true
    },
    comprobarSobreNosotros() {
      let check = this.editCliente.Datos_json.Descripcion_sobre_nosotros_corta;
      if(this.show == 'PantallaSobreNosotros')
        check = this.editCliente.Datos_json.Descripcion_sobre_nosotros;
      if (check.replace(/\s+/g, '') == '') {
        this.errorForm();
        return false;
      }
      return true;
    },
    comprobarDireccion() {
      // Comprobamos los campos obligatorios
      if (!this.editCliente.Datos_json.cp || this.editCliente.Datos_json.cp.replace(/\s+/g, '') == ''
      || !this.editCliente.Datos_json.Localidad ||  this.editCliente.Datos_json.Localidad.replace(/\s+/g, '') == ''
      || !this.editCliente.Datos_json.Provincia ||  this.editCliente.Datos_json.Provincia.replace(/\s+/g, '') == '') {
        this.errorForm();
        return false;
      }
      if(isNaN(Number(this.editCliente.Datos_json.cp))){
        this.toast.error("Revisa el campo Código Postal, no es un número")
        return false;
      }else{  
        return true;
      }
    },    
    comprobarFooter() {
      if (!this.validarURL(this.editCliente.Datos_json.Perfil_facebook)){
        this.toast.error("Revisa el campo Facebook, no es una URL válida")
        return false;
      }else if (!this.validarURL(this.editCliente.Datos_json.Perfil_instagram)){
        this.toast.error("Revisa el campo Instagram, no es una URL válida")
        return false;
      }else if (!this.validarURL(this.editCliente.Datos_json.Perfil_linkedin)){
        this.toast.error("Revisa el campo Linkedin, no es una URL válida")
        return false;
      }else if (!this.validarURL(this.editCliente.Datos_json.Perfil_twitter)){
        this.toast.error("Revisa el campo Twitter, no es una URL válida")
        return false;
      }else{
        return true;
      }      
    },  
    async comprobarFooterImg() {
      if (this.loadedImg) {
        // Si la imagen tiene un tamaño válido, proceder con la carga
        var response = await this.guardarImg(this.folder + '/footer_image' + this.loadedImgType, this.loadedImg.split("base64,")[1], this.removeAccents('Footer de ' + this.editCliente.Datos_json.Titulo_principal), 'Footer');
        if (response.status == 200) {
          this.editCliente.Datos_json.Img_Footer = 'footer_image' + this.loadedImgType;
          return true;
        } else {
          return false;
        }
      }
    },
    errorForm() {
      this.toast.error("Rellena todos los campos del formulario")
    },
    onChangeFont() {
      this.$emit('changeFont');
    },
    validarURL(curl) {
      if(curl.replace(/\s+/g, '') != ''){
        try {    
          new URL(curl);
          return true;    
        } catch (err) {    
          return false;    
        }
      }else{
        return true;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.controllerDiv {
  margin-bottom: 20px;
}

.wrap-services .controllerDiv {
  padding-bottom: 25px;
  border-bottom: 1px solid #dedeed;
}

.controllerInnerDiv {
  position: relative;
  display: flex;
  flex-direction: column;
}

.controllerTextDiv {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 5px;
}

.controllerTextDiv .action-box {
  background: transparent;
  border: 1px solid transparent;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
}

.controllerTextDiv .action-box i {
  font-size: 20px;
  cursor: pointer;
  color: #504f76;
  transition: all .25s ease-in-out;
}

.controllerTextDiv .action-box:hover {
  border: 1px solid var(--main-primary-color);
  background: #fff;
  border-radius: 4px;
}

.controllerTextDiv .action-box:hover i {
  color: var(--main-primary-color);
}

.controllerText {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  cursor: default;
}

/* SELECTOR DE COLOR */
.colorDiv {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  border-radius: 10px;
  color: var(--main-color-contrast);
  background-color: var(--main-color-hexa);
  cursor: pointer;
}

.colorDiv div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.colorDiv p {
  margin: 0;
}

.colorsContainer {
  width: 100%;
  height: auto;
  margin-top: 10px;
}

.colorsContainer .colorsDisplay {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.colors {
  height: 30px;
  width: 30px;
  border-radius: 5px;
  cursor: pointer;
}

/* SELECTOR DE IMG */
.controllerImgDrag {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #6362e7;
  border-radius: 15px;
  -o-border-image: none;
  border-image: none;
  background: rgba(99, 98, 231, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: 175px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.controllerImgDrag .controllerImgMessage i {
  font-size: 2.5rem;
  color: #6362e7;
  margin-bottom: 5px;
}

.controllerImgDrag .controllerImgMessage div {
  font-size: 14px;
}

.controllerImgDrag img {
  max-width: 100%;
  height: auto;
}

.menu-extra-switch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin: 8px 0 12px;
  padding: 4px;
  background: #f3f2fb;
  border-radius: 12px;
}

.menu-extra-switch button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 9px;
  padding: 8px 10px;
  background: transparent;
  color: #504f76;
  font-weight: 600;
  cursor: pointer;
}

.menu-extra-switch button.active {
  background: #fff;
  color: #6362e7;
  box-shadow: 0 1px 3px rgba(80, 79, 118, 0.16);
}

.menu-extra-url {
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-extra-url > i {
  color: #6362e7;
}

.menu-extra-drop {
  display: flex;
  width: 100%;
  min-height: 112px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 2px dashed #6362e7;
  border-radius: 15px;
  background: rgba(99, 98, 231, 0.1);
  color: #504f76;
}

.menu-extra-drop i {
  font-size: 2rem;
  color: #6362e7;
}

.menu-extra-picked {
  overflow: hidden;
  border: 1px solid #dedeed;
  border-radius: 12px;
  background: #fff;
}

.menu-extra-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 140px;
  background: #f7f6fc;
}

.menu-extra-preview img,
.menu-extra-preview embed {
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: contain;
}

.menu-extra-preview > i {
  font-size: 2rem;
  color: #6362e7;
}

.menu-extra-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid #dedeed;
  background: #fff;
}

.menu-extra-file > i {
  color: #6362e7;
}

.menu-extra-file-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-extra-file a,
.menu-extra-file button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #504f76;
}

.menu-extra-file a:hover,
.menu-extra-file button:hover {
  background: #f3f2fb;
  color: #6362e7;
}

/* INPUT TEXTO */
.inputTextDiv {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.controllerInnerDiv .inputTextDiv:last-child {
  margin-bottom: 0px !important;
}

.contact-visibility-options {
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(99, 98, 231, 0.06) 0%, rgba(99, 98, 231, 0.12) 100%);
  border: 1px solid rgba(99, 98, 231, 0.2);
}

.contact-visibility-row {
  font-size: 0.9rem;
  font-weight: 500;
  color: #1e2f65;
  cursor: pointer;
}

.contact-hint-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(145deg, #6362e7, #4b4ad4);
  box-shadow: 0 1px 4px rgba(99, 98, 231, 0.45);
  cursor: help;
  line-height: 1;
}
</style>
